export const getReportByName = (reportName, reports) => {
  const [reportByName] = reports.filter(report => report.name === reportName);
  return reportByName;
};

export const isDevURL = url => {
  const DEV_URL_PATTERN = /.*((int|pub)\.pr-[0-9]+|dev).*/;
  return DEV_URL_PATTERN.test(url);
};
